import { useState } from "react";
import { toast } from "sonner";
import { setSession } from "@/lib/auth";
import { postWithRetry } from "@/lib/retryPost";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const INITIAL_DRIVER_SIGNUP_FORM = {
  name: "", email: "", password: "", phone: "",
  city: "", state: "", cdlClass: "A", cdlNumber: "", experienceYears: "",
  trailerTypes: [], endorsements: [], serviceRadius: "250", listed: true, ageConfirmed: false,
};

// Creates a REAL RelayRigs app account (role=driver), saves the extended directory
// profile (endorsements/trailer types/service radius/listed flag), then redirects
// to the app's Stripe checkout — same account-creation pipeline used elsewhere on
// the site, just with an added "Find a Driver" directory listing.
export const useDriverSignup = (onRetrying) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (form) => {
    setSubmitting(true);
    try {
      const { data: authData } = await postWithRetry(`${API}/auth/register`, {
        name: form.name, email: form.email, password: form.password, role: "driver",
        phone: form.phone || null,
        home_city: form.city || null,
        home_state: form.state || null,
        cdl_class: form.cdlClass,
        cdl_number: form.cdlNumber || null,
        experience_years: Number(form.experienceYears) || null,
        accepted_legal: true,
        legal_version: "1.1",
        age_confirmed: form.ageConfirmed,
      }, onRetrying);
      setSession(authData.user);

      await postWithRetry(`${API}/drivers/profile`, {
        name: form.name, email: form.email, phone: form.phone || null,
        city: form.city || null, state: form.state || null,
        cdl_class: form.cdlClass, experience_years: Number(form.experienceYears) || null,
        endorsements: form.endorsements, trailer_types: form.trailerTypes,
        service_radius_miles: Number(form.serviceRadius) || null,
        listed: form.listed,
      }, onRetrying);

      toast.success(form.listed ? "You're in the directory! Redirecting to checkout..." : "Account created! Redirecting to checkout...");
      const { data: checkout } = await postWithRetry(`${API}/billing/checkout`, { plan: "driver" }, onRetrying);
      window.location.href = checkout.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
      setSubmitting(false);
    }
  };

  return { submitting, handleSubmit };
};
